import React from 'react'
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import { withRouter } from "react-router-dom";

class MotivoAtrasoEmbarque extends FormComponent {

  componentDidMount() {
    this.FormConfig(
      { defaultUrl: 'motivos-atraso-embarque/one', saveUrl: 'motivos-atraso-embarque/save', backUrl: '/Catalogo/MotivosAtrasoEmbarque' },
      new Form([
        Form.Field('text', 'motivo_clave', 'Clave', '', [Validators.required], 4),
        Form.Field('text', 'motivo_nombre', 'Descripcion', '', [Validators.required, Validators.maxLength(250)], 4),
      ], ['Guardar'], 'Motivo'), this.formData
    )
    if (this.props.match.params.id)
      this.LoadPreds()
  }

  render() {
    return (
      <div>
        <this.FormRender />
      </div>
    )
  }
}

export default withRouter(MotivoAtrasoEmbarque)
